import {
  AfterContentInit,
  Component,
  effect,
  inject,
  input,
  model,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import {
  ButtonComponent,
  ButtonOptions,
  ModalComponent,
  ModalOptions,
  TableComponent,
} from '@shared/components';
import { APIService } from '@core/services';
import { PatientService } from '@core/services/patient.service';
import { VaccinationEuvac } from '@core/classes/tables/vaccination-euvac';
import { HTTPMethods, ModalTypes } from '@core/enums';

@Component({
  selector: 'ncp-vaccination-status-action',
  imports: [ButtonComponent, ModalComponent],
  templateUrl: './vaccination-status-action.component.html',
  styleUrl: './vaccination-status-action.component.scss',
})
export class VaccinationStatusActionComponent implements OnInit, AfterContentInit, OnDestroy {
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);

  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('btn') public btn!: ButtonComponent;

  protected data = model<VaccinationEuvac>();
  protected allData = model<VaccinationEuvac[]>();
  protected reloadData = model<() => {}>();
  protected index = input<number>();
  protected tbl = model<TableComponent<VaccinationEuvac>>(new TableComponent());

  protected btnOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'action',
    })
  );

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.confirm,
    })
  );

  statusEffect = effect(() => {
    this.setConfirm();
  });

  setConfirm = () => {
    this.modOptions().title = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
    this.modOptions().message = this.row?.status === 1 ? 'confirm_disable' : 'confirm_enable';
    this.btnOptions().icon =
      this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
    this.btnOptions().class = '';
    this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
    this.modOptions().onYes = this.changeStatus;
  };

  ngOnInit() {
    this.btnOptions().onClick = () => {
      this.setConfirm();
      this.btn.blur();
      this.mod.open();
    };
  }

  ngOnDestroy() {
    this.statusEffect.destroy();
  }

  ngAfterContentInit() {}

  get row() {
    return this.data();
  }

  set row(row) {
    this.data.set(row);
  }

  protected changeStatus = () => {
    const status = this.data()?.status === 1 ? 0 : 1;

    this.apiService
      .call({
        path: '/vaccinations-euvac/status',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        type: HTTPMethods.PUT,
        body: {
          vaccination_mapping_id: this.data()?.vaccination_mapping_id,
          status: status,
        },
      })
      ?.subscribe((res: any) => {
        if (res && res.status?.toString() === '1') {
          const allData = this.allData() as VaccinationEuvac[];
          allData[this.index()!].status = status;
          this.row = allData[this.index()!];
          this.btnOptions().icon =
            this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
          this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
          (this.tbl() as TableComponent<VaccinationEuvac>).detectChanges();
          this.mod.close('success');
        }
      });
  };
}
